<template>
  <a href="javascript:void(0);" class="voice" @click="handleMedia(detail)" v-if="detail.mediaType">
    <span class="icon" :class="{ active: audioState }"></span>
    <span class="text">{{ detail.mediaType === 'video' ? '视频播放' : detail.cv }}</span>
  </a>
</template>

<script lang="ts" setup>
import roleHook from '@/hooks/roleHook';
const props = defineProps({
  detail: {
    type: Object,
    default: () => {
      return {
        mediaType: '',
      }
    }
  },
});
const { handleMedia, audioState } = roleHook();
</script>
